import Plyr from "plyr";

const VoiceCard = () => {
	const block = document.querySelectorAll(".voice-card");
	if (!block.length) {
		return;
	}

	const updateBar = (track) => {
		const currentTime = track.currentTime;
		const duration = track.duration;
		const percentage = currentTime / duration;
		const progress = 100 * percentage;

		const overlay = track.media.closest(".voice-card").querySelector(".voice-card__control-progress");

		overlay.style.width = `${progress}%`;
	};

	const players = Plyr.setup(document.querySelectorAll(".voice-card__track"), {
		controls: [
			"play"
		],
	});

	players.forEach(player => {
		player.on("timeupdate", () => {
			updateBar(player);
		});

		player.on("play", () => {
			player.media.closest(".voice-card").querySelector(".voice-card__control").classList.add("active");
			const others = players.filter(other => other != player);

			// pause other audios
			document.querySelectorAll("audio").forEach(item => {
				if (!item.closest(".voice-card")) {
					item.pause();
				}
			});

			others.forEach(other => {
				other.pause();
			});
		});

		player.on("pause", () => {
      const card = player.media.closest(".voice-card");
			card.querySelector(".voice-card__control").classList.remove("active");
      card.classList.remove("active");
		});
	});

  block.forEach((el) => {
		const thisBlock = el;
    const control = thisBlock.querySelector(".voice-card__control");

    control.addEventListener("click", (e) => {
      const parent = e.target.closest(".voice-card");
      const track = parent.querySelector(".voice-card__track");

      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
        track.pause();
      } else {
        parent.classList.add("active");
        track.play();
      }
    });
  });
};


export default VoiceCard;